import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from '../components/ui';
import { ExternalLink, ArrowRightLeft } from 'lucide-react';
import { SHOULD_USE_MOCKS } from '../lib/clerk';

export const StripeMockDashboardPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!SHOULD_USE_MOCKS) {
      navigate('/settings/payouts', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F6F8FA] flex flex-col items-center pt-20 px-4">
      <div className="w-full max-w-3xl mb-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-[#635BFF] rounded-none text-white font-bold flex items-center justify-center">S</div>
          <span className="font-bold text-gray-900 dark:text-gray-100 text-lg">Stripe Express <span className="text-gray-400 font-normal text-sm ml-2">(Development Mock)</span></span>
        </div>
        <Button variant="ghost" onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-900">
          Return to Platform <ExternalLink size={14} className="ml-2" />
        </Button>
      </div>

      <Card className="w-full max-w-3xl p-8 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.1)] border-none rounded-none">
        <div className="space-y-8">
          
          <div className="p-8 bg-white border-2 border-black dark:border-white rounded-none shadow-[4px_4px_0px_#000000] dark:shadow-[4px_4px_0px_#FFFFFF] dark:bg-slate-900">
            <p className="text-sm text-gray-500 dark:text-gray-400 font-medium mb-2 uppercase tracking-wide">Available to pay out</p>
            <div className="flex items-end justify-between">
              <p className="text-5xl font-black text-gray-900 dark:text-white">$1,240.00</p>
              <Button className="bg-[#635BFF] hover:bg-[#5851E5] text-white border-none rounded-none px-6">
                Pay out
              </Button>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 dark:text-gray-100 mb-4 text-lg">Recent Transactions</h3>
            <div className="bg-white border-2 border-black dark:border-white rounded-none overflow-hidden divide-y divide-gray-100 dark:bg-slate-900">
              {[
                { desc: "Payment from James Avery", amount: "+$50.00", fee: "-$0.15", date: "Today, 10:42 AM" },
                { desc: "Payment from Jane Smith", amount: "+$25.00", fee: "-$0.15", date: "Yesterday, 2:15 PM" },
                { desc: "Payout to Bank ending in ••••6789", amount: "-$850.00", fee: "$0.00", date: "Oct 12, 9:00 AM", isPayout: true },
              ].map((tx, idx) => (
                <div key={idx} className="p-4 flex items-center justify-between hover:bg-white transition-colors dark:bg-slate-950">
                  <div className="flex items-center gap-4">
                    <div className={`w-10 h-10 rounded-none flex items-center justify-center ${tx.isPayout ? 'bg-white text-gray-500 dark:bg-slate-800' : 'bg-green-100 text-green-600'}`}>
                      <ArrowRightLeft size={16} />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900 dark:text-white">{tx.desc}</p>
                      <p className="text-xs text-gray-500">{tx.date} • Fee: {tx.fee}</p>
                    </div>
                  </div>
                  <span className={`font-bold font-mono ${tx.isPayout ? 'text-gray-900' : 'text-green-600'}`}>{tx.amount}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};